module.exports = __webpack_public_path__ + "img/holden.92ffc8c0.jpeg";